module.exports = __webpack_public_path__ + "static/media/ao.5b862483.svg";